import { get } from 'lodash';
import React, { useEffect, useState } from 'react';
import { useAuthentication } from 'src/context/AuthContext';
import GetRecord from 'src/lib/api/GetRecord';
import { APIS } from 'src/lib/constants/apis';
import { AUTH_TOKEN_DATA } from 'src/lib/constants/constant';
import { isOrgaAbteilungEinerHochschule, removeDataKeys, removeNullDeep } from 'src/utils/helper';
import OrganisationDataHochschule from './organisation-data-hochschule/OrganisationDataHochschule';
import OrganisationData from './organisation-data/OrganisationData';

const OrganisationsProfil = () => {
	const { authenticatedData } = useAuthentication();
	const [organisationData, setOrganisationData] = useState<Record<string, any>>({});

	useEffect(() => {
		const fetchOrganisation = async () => {
			try {
				let res = await GetRecord(APIS.Organisation, get(authenticatedData, AUTH_TOKEN_DATA.organisationId, ''));
				setOrganisationData(removeNullDeep(removeDataKeys(get(res, 'data', {}))));
			} catch (err) {
				console.error('ERROR Fetching Organisation ', err);
			}
		};
		fetchOrganisation();
	}, [authenticatedData]);

	if (isOrgaAbteilungEinerHochschule(organisationData)) {
		return <OrganisationDataHochschule />;
	} else {
		return <OrganisationData />;
	}
};

export default OrganisationsProfil;
